/**
 * Convierte "YYYY-MM-DD" a "DD/MM/YYYY" para mostrar en el frontend.
 * Si la fecha está vacía o no tiene el formato esperado, retorna "".
 */
export default function fmtFecha(fecha) {
  if (!fecha || !fecha.includes("-")) return "";
  const [y, m, d] = fecha.split("-");
  return `${d}/${m}/${y}`;
}
